import axiosClient from './axiosClient'

const manageUsersApi = {
  addUser: (payload) => axiosClient.post(`/api/manage-users`, payload),
  removeUser: (payload) => axiosClient.delete(`/api/manage-users`, payload),
}

export default manageUsersApi
